export default __webpack_public_path__ + "static/media/floor_and_threshold_desk.d9f4fe35.png";